import React from 'react'
import { Table, TableBody, TableCell, TableHead, TableRow } from '@mui/material'
import { t } from 'i18next'

type Props = {
  children?: React.ReactNode
  currencyHeadCells: string[]
}

const CurrenciesTableComponent = ({ children, currencyHeadCells }: Props) => {
  return (
    <Table>
      <TableHead sx={{ th: { padding: '8px' } }}>
        <TableRow>
          {currencyHeadCells.map((cell, index) => (
            <TableCell key={`${cell}_${index}`}>{t(`${cell}`)}</TableCell>
          ))}
        </TableRow>
      </TableHead>
      <TableBody>{children}</TableBody>
    </Table>
  )
}

export default CurrenciesTableComponent
